import { Component, Output, EventEmitter } from '@angular/core';
import { Utils } from '../../../utils';

@Component({
  selector: 'app-page-size-selector',
  templateUrl: './page-size-selector.component.html'
})
export class PageSizeSelectorComponent {

  selectedSize = Utils.defaultPageSize;
  sizes = [5, 10, 25, 50];

  @Output() sizeSelected = new EventEmitter<number>();

  constructor() { }

  onSelectSize(size) {
    this.selectedSize = size;
    this.sizeSelected.emit(size);
  }
}
